
export const formDataEMI = {
    "dimensao": "ESTRATÉGIAS METODOLÓGICAS PARA INOVAÇÃO",
    "questoes": [
        {
            "pergunta": "Realiza estudos prospectivos?*",

            "alternativas": [
                "Nem sei do que se trata.",

                "Sei o que é, mas nunca realizamos.",

                "Já realizamos um estudo prospectivo de interesse como uma ação isolada, sem perspectiva de novas realizações.",

                "<b>Eventualmente,</b> realizamos estudos prospectivos de interesse da organização.",

                "<b>Sistematicamente,</b> realizamos estudos prospectivos de interesse da organização."
            ]
        },
        {
            "pergunta": "Realiza reuniões com seus colaboradores?*",
            
            "alternativas": [
                "Não realizamos reuniões com a equipe, delegando ao(s) responsável(is) pelo(s) setor(es)/área(s) a responsabilidade de estabelecer e monitorar atividades a serem realizadas.",

                "<b>Eventualmente</b>, realizamos reuniões apenas com o(s) responsável(is) pelo(s) setor(es)/área(s) para fins de identificação de problemas ou gargalos/limitantes.",

                "<b>Sistematicamente</b>, realizamos reuniões apenas com o(s) responsável(is) pelo(s) setor(es)/área(s) para fins de identificação de problemas  ou gargalos/limitantes.",

                "<b>Eventualmente</b>, realizamos reuniões com o(s) responsável(is) pelo(s) setor(es)/área(s)  e/ou com colaboradores para identificação de problemas  ou gargalos/limitantes, <b>com estabelecimento de metas, indicadores e planos de ação.</b>",

                "<b>Sistematicamente</b>, realizamos reuniões com o(s) responsável(is) pelo(s) setor(es)/área(s)  e/ou com colaboradores para identificação de problemas  ou gargalos/limitantes, <b>com estabelecimento de metas, indicadores e planos de ação.</b>"
            ]
        }
    ]
}

export const formDataGGPI = {
    "dimensao": "GERAÇÃO E GESTÃO DA PROPRIEDADE INTELECTUAL (PI) E TRANSFERÊNCIA DE TECNOLOGIA (TT)",
    "questoes": [
        {
            "pergunta": "Gera propriedade intelectual da empresa e realiza sua gestão?*",

            "alternativas": [
                "Ainda não geramos propriedade intelectual, nem mesmo o registro da marca da empresa.",

                "Somente demos entrada ou temos o certificado de registro da <b>marca</b> da empresa junto ao INPI.",
                
                "Sim, demos entrada em pelo menos 1 pedido de proteção da PI (patente, RPC ou desenho industrial) <b>ou</b> estabelecemos a meta de lançar pelo menos 1 novo produto ou uma melhoria de processo  a cada ano.",
                
                "Sim, demos entrada em pelo menos 1 pedido de proteção da PI (patente, RPC ou desenho industrial) <b>e</b> estabelecemos a meta de lançar pelo menos 1 novo produto ou uma melhoria de processo  a cada ano.",
                
                "Sim, demos entrada em pelo menos 1 pedido de proteção da PI (patente, RPC ou desenho industrial), estabelecemos a meta de lançar pelo menos 1 novo produto ou uma melhoria de processo  a cada ano e <b>dispomos de responsável pela gestão da PI.</b>"
            ]
        },
        {
            "pergunta": "Sobre o processo de Transferência de Tecnologia (TT):*",

            "alternativas": [
                "Nunca realizamos TT.",
                "Nunca realizamos, mas dispomos de vitrine tecnológica.",
                "Dispomos de vitrine tecnológica e temos um funcionário designado especificamente para os processos de TT.",
                "Dispomos de vitrine tecnológica, temos um funcionário designado especificamente para os processo de TT <b>e já concluímos pelo menos um processo de TT.</b>",
                "Dispomos de vitrine tecnológica, temos um funcionário designado especificamente para os processo de TT e já concluímos mais de um processo de TT <b>ou nossas tecnologias são protegidas por patentes ou RPCs somente com objetivo defensivo.</b>"
            ]
        }
    ]
}

export const formDataAIO = {
    "dimensao": "AÇÕES DE INOVAÇÃO ORGANIZACIONAL",
    "questoes": [
        {
            "pergunta": "Quanto às ações de inovação em processos (incluindo aquelas relacionadas à redução dos impactos ambientais negativos):*",

            "alternativas": [
                "Mantivemos os mesmos insumos, variáveis operacionais, etapas, fontes energéticas e os demais recursos naturais dos últimos 2 anos.",

                "Realizamos mudanças nos insumos (ou variáveis operacionais ou etapas dos processos) <b>ou</b> inserimos fontes alternativas de energia <b>ou</b> outras formas de redução do uso de recursos naturais nos últimos 2 anos.",

                "Realizamos mudanças nos insumos (ou variáveis operacionais ou etapas dos processos) <b>e</b> inserimos fontes alternativas de energia <b>ou</b> outras formas de redução do uso de recursos naturais nos últimos 2 anos.",

                "Realizamos mudanças nos insumos (ou variáveis operacionais ou etapas dos processos), inserimos fontes alternativas de energia ou outras formas de redução do uso de recursos naturais nos últimos 2 anos, <b>bem como temos plano de ação em andamento.</b>",

                "Realizamos mudanças nos insumos (ou variáveis operacionais ou etapas dos processos), inserimos fontes alternativas de energia ou outras formas de redução do uso de recursos naturais nos últimos 2 anos, <b>temos plano de ação em andamento e planejamento para novos planos de ação.</b>"
            ]
        },
        {
            "pergunta": "Quanto à automação e/ou digitalização de processos administrativos e/ou de produção:*",

            "alternativas": [
                "Ainda realizamos tudo manual, exceto para atividades administrativas de rotina, como edição de texto e emissão de notas fiscais.",

                "Aproximadamente 25% dos processos estão automatizados.",

                "Aproximadamente 50% dos processos estão automatizados.",

                "Aproximadamente 70% dos processos estão automatizados.",

                "Mais de 90% dos processos estão automatizados."
            ]
        },
        {
            "pergunta": "Quanto ao acesso a mercados e relacionamento com clientes e colaboradores:*",

            "alternativas": [
                "Não realizamos ações de marketing ou o fazemos apenas quando há grande redução nos lucros, bem como não mantemos relacionamento com os clientes (exceto o atendimento no momento da aquisição do serviço ou produto).",

                "Realizamos ações de marketing (utilizando diferentes métodos) <b>ou</b> mantemos ações voltadas ao relacionamento futuro com os clientes.",

                "Realizamos ações de marketing (utilizando diferentes métodos) <b>e</b> mantemos ações voltadas ao relacionamento futuro com os clientes.",

                "Realizamos ações de marketing (utilizando diferentes métodos), mantemos ações voltadas ao relacionamento futuro com os clientes <b>e, eventualmente, elaboramos modelos de negócios para novos produtos ou serviços.</b>",

                "Utilizamos métodos de marketing (utilizando diferentes métodos), mantemos ações voltadas ao relacionamento futuro com os clientes e, <b>sistematicamente</b>, elaboramos modelos de negócios para novos produtos ou serviços."
            ]
        }
    ]
}

export const formDataIGC = {
    "dimensao": "INVESTIMENTO PARA GERAÇÃO DE CONHECIMENTO",
    "questoes": [
        {
            "pergunta": "Quanto ao investimento em pesquisa e desenvolvimento:*",

            "alternativas": [
                "Não investimos em pesquisa e desenvolvimento (P&D), nem em novos equipamentos, <b>exceto por defeito permanente ou grande custo com manutenção.</b>",

                "<b>Apenas oportunamente</b>, já investimos em (P&D), incluindo a possibilidade de aquisição de novos equipamentos.",

                "<b>Investimos, eventualmente</b>, em (P&D), incluindo a possibilidade de aquisição de novos equipamentos, <b>embora sem valores anuais pré-definidos para este fim.</b>",

                " Investimos, <b>sistematicamente</b>, pelo menos <b>3% dos recursos sobressalentes a partir da projeção do fluxo de caixa</b> em (P&D), incluindo a possibilidade de aquisição de novos equipamentos.",

                "Investimos, <b>sistematicamente</b>, pelo menos <b>10% dos recursos sobressalentes a partir da projeção do fluxo de caixa</b> em (P&D), incluindo a possibilidade de aquisição de novos equipamentos."
            ]
        },
        {
            "pergunta": "Quanto à capacitação dos funcionários:*",

            "alternativas": [
                " Não há previsão de incentivos para capacitação dos funcionários.",

                "Já ocorreu antes, mas não há previsão formal.",

                "Somente os responsáveis pelos setores são incentivados a participarem de treinamentos e/ou de eventos.",

                "Os funcionários são incentivados a participarem de pelo menos um evento ou treinamento ou ainda pós-graduação",

                "Os funcionários são incentivados a participarem de pelo menos um evento ou treinamento ou ainda pós-graduação, <b>com possibilidade de bolsa ou outra ajuda de custo.</b>"
            ]
        },
        {
            "pergunta": "Quanto ao incentivo à geração de ideias pelos funcionários e/ou clientes:*",

            "alternativas": [
                "Nunca ocorreu e não há previsão de incentivos para os funcionários e/ou clientes visando proposição de soluções para gargalos da organização.",

                "Já ocorreu antes, mas não há previsão formal.",

                "<b>Eventualmente</b>, são realizados desafios de ideias (ou ações similares), com ou sem reconhecimento/premiação (financeira e/ou não financeira) para as melhores soluções apresentadas.",

                "<b>Sistematicamente</b>, são realizados desafios de ideias (ou ações similares), com ou sem reconhecimento/premiação (financeira e/ou não financeira) para as melhores soluções apresentadas.",

                "<b>Sistematicamente</b>, são realizados desafios de ideias (ou ações similares), com ou sem reconhecimento/premiação (financeira e/ou não financeira) para as melhores soluções apresentadas, <b>além de termos normativo prevendo percentual, para o(os) autor(es), dos ganhos auferidos a partir de licenciamento(s) ou cessão(ões) de tecnologia(s).</b>"
            ]
        },
        {
            "pergunta": "Há parceria técnico-científica com outras organizações?*",

            "alternativas": [
                "Não há e não temos interesse.",

                "Temos interesse, mas não houve oportunidade <b>ou já faz mais de 3 anos.</b>",

                "Temos ou tivemos parceria(s), <b>nos últimos 3 anos</b>, vinculada(s) a projeto(s), como Trabalho de Conclusão de Curso-TCC, Iniciação Tecnológica ou outro, com desenvolvimento tecnológico.",

                "Temos ou tivemos parceria(s), <b>nos últimos 3 anos</b>, vinculada(s) a projeto(s), como Trabalho de Conclusão de Curso-TCC, Iniciação Tecnológica ou outro, com desenvolvimento tecnológico <b>e formalizada(s) por meio de ACT(s), convênio(s) ou similar(es).</b>",

                "Temos ou tivemos parceria(s), <b>nos últimos 3 anos</b>, vinculada(s) a projeto(s), como Trabalho de Conclusão de Curso-TCC, Iniciação Tecnológica ou outro, com desenvolvimento tecnológico, <b>formalizada(s) por meio de ACT(s), convênio(s) ou similar(es) e incluindo pedido de proteção de propriedade intelectual gerada.</b>"
            ]
        }
    ]
}

export const formDataPG = {
    "dimensao": "PERFIL DO GESTOR",
    "questoes": [
        {
            "pergunta": "Quanto ao perfil do gestor:*",

            "alternativas": [
                "Gestor tradicional, que não está aberto à escuta dos colaboradores e tem grande resistência a mudanças.",

                "Gestor tradicional, que está receptivo às sugestões dos colaboradores, mas tendo muito receio quanto aos riscos, não as coloca em prática.",

                "Gestor que está receptivo às sugestões dos colaboradores, mas apenas eventualmente atribui prioridade às ações necessárias para implementá-las.",

                "Gestor inovador, que está receptivo às sugestões dos colaboradores e empreende esforços para implementá-las.",

                "Gestor inovador, que está receptivo às sugestões dos colaboradores, empreende esforços para implementá-las <b>e conta com experiência na implementação de inovações.</b>"
            ]
        }
    ]
}